export const MUX_PLAYBACK_ENGINE = Object.freeze({
  HLS_JS: "hls.js",
  NATIVE_HLS: "native-hls",
  UNSUPPORTED: "unsupported",
});

export function detectMuxPlaybackEnvironment(userAgent = "") {
  const ua = String(userAgent || "");
  const mobile = /Mobi|Android|iPhone|iPad|iPod/i.test(ua);
  let browserFamily = "other";
  if (/Edg\//.test(ua)) browserFamily = "edge";
  else if (/OPR\//.test(ua)) browserFamily = "opera";
  else if (/(?:Chrome|CriOS)\//.test(ua)) browserFamily = "chrome";
  else if (/(?:Firefox|FxiOS)\//.test(ua)) browserFamily = "firefox";
  else if (/Safari\//.test(ua) && /Version\//.test(ua)) browserFamily = "safari";
  return {
    browserFamily,
    deviceClass: mobile ? "mobile" : "desktop",
    desktopChromium: !mobile && ["chrome", "edge", "opera"].includes(browserFamily),
  };
}

export function shouldProbeHlsJsFirst(environment) {
  return environment?.desktopChromium === true;
}

export function selectMuxPlaybackEngine({
  preferHlsJs = false,
  nativeHlsSupported = false,
  mediaSourceSupported = false,
  hlsJsSupported = false,
} = {}) {
  if (preferHlsJs && mediaSourceSupported && hlsJsSupported) {
    return MUX_PLAYBACK_ENGINE.HLS_JS;
  }
  if (nativeHlsSupported) return MUX_PLAYBACK_ENGINE.NATIVE_HLS;
  if (mediaSourceSupported && hlsJsSupported) return MUX_PLAYBACK_ENGINE.HLS_JS;
  return MUX_PLAYBACK_ENGINE.UNSUPPORTED;
}
